import { Component, OnInit, Inject  } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-notification-payment',
  templateUrl: './notification-payment.component.html',
  styleUrls: ['./notification-payment.component.scss']
})
export class NotificationPaymentComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  ngOnInit(): void {
  }

}
